import { render, staticRenderFns } from "./card-management-insight.vue?vue&type=template&id=18860071&scoped=true&"
var script = {}
import style0 from "./card-management-insight.vue?vue&type=style&index=0&id=18860071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18860071",
  null
  
)

component.options.__file = "card-management-insight.vue"
export default component.exports